import { render } from "./FavoritePagesEditor.vue?vue&type=template&id=a5cb5934&scoped=true"
import script from "./FavoritePagesEditor.vue?vue&type=script&lang=js"
export * from "./FavoritePagesEditor.vue?vue&type=script&lang=js"

import "./FavoritePagesEditor.vue?vue&type=style&index=0&id=a5cb5934&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5cb5934"]])

export default __exports__